export default {

	methods: {
		showLoader(text = '') {
			this.$store.dispatch('loader/show', text);
		},

		hideLoader() {
			this.$store.dispatch('loader/hide');
		},


		generateRandomKey() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0,
					v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(36);
			});
		},

		gotoRoute(route) {
			this.$router.push(route);
		},

		gotoCourse(courseId) {
			this.gotoRoute('/courses/' + courseId);
		},

		gotoLesson(courseId, unitId, lessonId) {
			this.gotoRoute('/courses/' + courseId + '/unit/' + unitId + '/lessons/' + lessonId);
		},

		goToDocument(documentId) {
			this.gotoRoute('/e-studio/' + documentId)
		},

		gotoProject(groupId, userId, projectId) {
			this.gotoRoute('/projects/' + groupId + '/' + userId + '/' + projectId);
		},

		gotoEStudio(projectId) {
			this.gotoRoute('/e-studio/project/' + projectId);
		},
		gotoForum() {
			this.gotoRoute('/forum')
		},
		gotoPost(forumId, topicId, postId) {
			this.gotoRoute('/forum/' + forumId + '/topics/' + topicId + '/post/' + postId);
		},
		gotoProjectReview(studentName, documentId) {
			this.gotoRoute('/students/projectreview/' + studentName + '/' + documentId)
		}
	}
};
